import {useState} from 'react';

/**
 * Teclado na tela do totem. Numérico por padrão, com modo de letras
 * para CNPJ alfanumérico. Teclas redondas, visual leve.
 */

interface TotemTecladoProps {
	onTecla: (tecla: string) => void;
	onApagar: () => void;
	onLimpar: () => void;
	onConfirmar: () => void;
	confirmarHabilitado: boolean;
	carregando?: boolean;
}

const NUMEROS = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const LETRAS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export function TotemTeclado({onTecla, onApagar, onLimpar, onConfirmar, confirmarHabilitado, carregando}: TotemTecladoProps) {
	const [modo, setModo] = useState<'num' | 'abc'>('num');

	return (
		<div className="totem-teclado">
			<div className={`totem-teclado-teclas totem-teclado-${modo}`}>
				{modo === 'num' && (
					<>
						{NUMEROS.map(n => (
							<button key={n} type="button" className="totem-tecla" onClick={() => onTecla(n)} disabled={carregando}>{n}</button>
						))}
						<button type="button" className="totem-tecla totem-tecla-secundaria" onClick={() => setModo('abc')} disabled={carregando} title="Letras (CNPJ alfanumérico)">abc</button>
						<button type="button" className="totem-tecla" onClick={() => onTecla('0')} disabled={carregando}>0</button>
						<button type="button" className="totem-tecla totem-tecla-secundaria" onClick={onApagar} disabled={carregando} title="Apagar">
							<span className="material-icons" aria-hidden="true">backspace</span>
						</button>
					</>
				)}
				{modo === 'abc' && (
					<>
						{LETRAS.map(l => (
							<button key={l} type="button" className="totem-tecla" onClick={() => onTecla(l)} disabled={carregando}>{l}</button>
						))}
						<button type="button" className="totem-tecla totem-tecla-secundaria" onClick={() => setModo('num')} disabled={carregando} title="Números">123</button>
						<button type="button" className="totem-tecla totem-tecla-secundaria" onClick={onApagar} disabled={carregando} title="Apagar">
							<span className="material-icons" aria-hidden="true">backspace</span>
						</button>
					</>
				)}
			</div>
			<button type="button" className="totem-botao totem-botao-primario totem-teclado-confirmar" onClick={onConfirmar} disabled={!confirmarHabilitado || carregando}>
				{carregando ? 'Procurando...' : 'Ver meus boletos'}
				{!carregando && <span className="material-icons" aria-hidden="true">arrow_forward</span>}
			</button>
			<button type="button" className="totem-link totem-teclado-limpar" onClick={onLimpar} disabled={carregando}>
				começar de novo
			</button>
		</div>
	);
}
